import "./location.css";

import location from "../../../../assets/images/icons/location.svg";
import shop from "../../../../assets/images/icons/shop.svg";
import schedule from "../../../../assets/images/icons/schedule.svg";

export const LocationModal = ({props}) => {
    
   
    return (
        <div className="modal fade" id="location-modal" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-fullscreen">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-4" id="exampleModalSmLabel">{props?.[0]?.value}</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className=" border-bottom border-secondary-subtle">
                            <div className="d-flex align-items-center">
                                <img src={shop} alt="" />
                                <p className="h3 m-0 ms-2">Про нас</p>
                            </div>
                            <p className="fs-5 ms-3">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Vitae laboriosam quam natus repellendus enim architecto asperiores incidunt ut, perferendis nulla.</p>
                        </div>
                        <div className=" mt-3 border-bottom border-secondary-subtle">
                            <div className="d-flex align-items-center">
                                <img src={location} alt="" />
                                <p className="h3 m-0 ms-2">Адреса</p>
                            </div>
                            <p className="fs-5 ms-3">
                                {props?.[1]?.value}
                            </p>
                        </div>
                        <div className=" mt-3">
                            <div className="d-flex align-items-center">
                                <img src={schedule} alt="" />
                                <p className="h3 m-0 ms-2">Графік роботи</p>
                            </div>
                            <ul className="ms-3">
                                <p className="fs-6 fw-bold">Понеділок - П'ятниця</p>
                                <li className="list-group-item ms-3">08:00 - 23:00</li>
                                
                            </ul>
                            <ul className="ms-3">
                                <p className="fs-6 fw-bold">Суббота</p>
                                <li className="list-group-item ms-3">10:00 - 18:00</li>
                                
                            </ul>
                            <ul className="ms-3">
                                <p className="fs-6 fw-bold">Неділя</p>
                                <li className="list-group-item ms-3">12:00 - 18:00</li>
                                
                            </ul>
                        </div>
                    </div>
                    <div className="modal-footer call-wrap">
                        <a className="call-button fs-5 fw-bold" href={`tel:${props?.[2]?.value}`}>
                            Зателефонувати
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}